var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageBox"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content"},[_c('menuItem',{attrs:{"menuData":_vm.menuData,"isTypeExamin":_vm.isTypeExamin}})],1),_c('div',{staticClass:"bnt",on:{"click":_vm.showMenu}},[_vm._v(_vm._s(_vm.bntText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }